import { envConfig } from "@/config";
import { frontendDomains } from "./getBackendUrl";

export function getGoogleLoginClientId(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.GOOGLE_LOGIN_CLIENT_ID_OVERRIDE) return envConfig.GOOGLE_LOGIN_CLIENT_ID_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.GOOGLE_LOGIN_CLIENT_ID_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.GOOGLE_LOGIN_CLIENT_ID_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.GOOGLE_LOGIN_CLIENT_ID_AU;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.GOOGLE_LOGIN_CLIENT_ID_US;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.GOOGLE_LOGIN_CLIENT_ID_UK;

	// Default to SIT region
	return envConfig.GOOGLE_LOGIN_CLIENT_ID_SIT;
}

export function getMicrosoftLoginClientId(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.MICROSOFT_LOGIN_CLIENT_ID_OVERRIDE) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_AU;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_US;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.MICROSOFT_LOGIN_CLIENT_ID_UK;

	// Default to SIT region
	return envConfig.MICROSOFT_LOGIN_CLIENT_ID_SIT;
}

export function getClasslinkLoginClientId(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.CLASSLINK_LOGIN_CLIENT_ID_OVERRIDE) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_AU;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_US;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.CLASSLINK_LOGIN_CLIENT_ID_UK;

	// Default to SIT region
	return envConfig.CLASSLINK_LOGIN_CLIENT_ID_SIT;
}

export function getClasslinkLoginRedirectUri(frontendDomain: string): string {
	if (frontendDomains.sit.includes(frontendDomain) || frontendDomains.stg.includes(frontendDomain))
		return envConfig.CLASSLINK_LOGIN_REDIRECT_URI_SIT_STG;
	return envConfig.CLASSLINK_LOGIN_REDIRECT_URI;
}

export function shouldShowClasslinkLoginOption(frontendDomain: string): boolean {
	// Show Classlink login only for SIT, STG, and US regions
	// Hide for AU and UK regions
	if (frontendDomains.sit.includes(frontendDomain)) return true;
	if (frontendDomains.stg.includes(frontendDomain)) return true;
	if (frontendDomains.usce1.includes(frontendDomain)) return true;

	// Return false for AU (ause1), UK (euwe2), and any other regions
	return false;
}
